export enum STATUS {
  DRAFT = "DRAFT",
  WAITING_OPEN = "WAITING_OPEN",
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  WAIT_FOR_CONSIDER = "WAIT_FOR_CONSIDER",
  APPROVE = "APPROVE",
  REJECT = "REJECT",
}
export const status: {
  label: string;
  value: string;
}[] = [
    {
      label: "บันทึกร่าง",
      value: STATUS.DRAFT,
    },
    {
      label: "ยังไม่ถึงวันที่เปิดให้จอง",
      value: STATUS.WAITING_OPEN,
    },
    {
      label: "เปิดให้จอง",
      value: STATUS.OPEN,
    },
    {
      label: "สิ้นสุดวันเปิดให้จอง",
      value: STATUS.CLOSED,
    },
    {
      label: "รอพิจารณา",
      value: STATUS.WAIT_FOR_CONSIDER,
    },
    {
      label: "อนุมัติการจอง",
      value: STATUS.APPROVE,
    },
    {
      label: "ไม่อนุมัติการจอง",
      value: STATUS.REJECT,
    },
  ];

export const status_e_the_sis_data = status


export const renderStatus = (value: string, string_other?: string): string => {
  return `${status.find((x) => x.value === value)?.label ||
    status.find((x) => x.value.split(",").includes(value))?.label ||
    ""
    }${string_other || ""}`;
};



export enum THESIS_PROGRESS_STEP_ENUM {
  NOT_STARTED = 'NOT_STARTED', //ยังไม่ดำเนินการ
  SUCCESS = 'SUCCESS', //ดำเนินการ
}


export enum THESIS_PROGRESS_STATUS {
  WAITING = 'WAITING',
  APPROVED = 'APPROVE',
  REJECTED = 'REJECT',
}

export const thesis_progress_status_data: { label: string, value: string }[] = [
  {
    label: "ผ่านการตรวจสอบ",
    value: THESIS_PROGRESS_STATUS.APPROVED
  },
  {
    label: "ไม่ผ่านการตรวจสอบ",
    value: THESIS_PROGRESS_STATUS.REJECTED
  },
  {
    label: "รอพิจารณา",
    value: THESIS_PROGRESS_STATUS.WAITING
  },
]